class $7c968f807e86b920$export$dc04438abaadc40 {
    getPrint(level) {
        return (...args)=>{
            if (!this.element) return;
            let string = "";
            args.forEach((arg, i)=>{
                if (!arg) return;
                if (i > 0) string += " ";
                if (arg.startsWith && arg.startsWith("%c")) arg = arg.substring(2);
                if (arg === "font-weight:bold;") return;
                if (arg.substring) string += arg;
                else string += JSON.stringify(arg);
            });
            const entry = this._getEntryElement(level, string);
            if (this.element.childElementCount > 0) {
                const insertionPoint = this.element.firstElementChild;
                this.element.insertBefore(entry, insertionPoint);
            } else this.element.appendChild(entry);
        };
    }
    get log() {
        return this.getPrint("log");
    }
    get warn() {
        return this.getPrint("warn");
    }
    get error() {
        return this.getPrint("error");
    }
    _getEntryElement(level, content) {
        let borderColor = "#aaa";
        let textColor = "#222";
        if (level === "warn") {
            textColor = "#540";
            borderColor = "#870";
        } else if (level === "error") {
            textColor = "#500";
            borderColor = "#800";
        }
        const entry = document.createElement("CODE");
        entry.innerText = content;
        entry.classList.add("debug-visualize__entry");
        entry.classList.add(`debug-visualize__entry--${level}`);
        entry.style.display = "block";
        entry.style.marginBottom = "1rem";
        entry.style.padding = ".25rem";
        entry.style.paddingLeft = ".5rem";
        entry.style.backgroundColor = "#ddd";
        entry.style.borderLeft = `10px solid ${borderColor}`;
        entry.style.color = textColor;
        return entry;
    }
    constructor(){
        this.element = null;
        const container = document.querySelector("#debug-visualize");
        if (!container) return;
        container.style.display = "block";
        container.style.maxHeight = "50vh";
        container.style.overflowY = "auto";
        container.style.fontSize = "1.5em";
        this.element = document.createElement("div");
        this.element.classList.add("console");
        this.element.style.width = "100%";
        container.appendChild(this.element);
    }
}


class $ec0e259d2aad5b8c$var$BasicDebugHelper {
    enable() {
        this._enabled = true;
        return this;
    }
    disable() {
        this._enabled = false;
        return this;
    }
    toggle(enabled) {
        this._enabled = enabled;
        return this;
    }
    toggleVisualization(enabled) {
        this._visualize = enabled;
        return this;
    }
    log(...args) {
        if (this._enabled) this._parent.log(this._prefix, ...args);
    }
    warn(...args) {
        if (this._enabled) this._parent.warn(this._prefix, ...args);
    }
    error(...args) {
        if (this._enabled) this._parent.error(this._prefix, ...args);
    }
    devnull(...args) {
        return args;
    }
    async timeout(ms) {
        return new Promise((res)=>{
            setTimeout(()=>res(), ms);
        });
    }
    get _prefix() {
        return this._namespace !== null ? `[${this._namespace}]` : "";
    }
    constructor(namespace = null, enabled = true, parent = null){
        this._enabled = false;
        this._namespace = null;
        this._parent = this;
        this._visualize = false;
        this._visualizer = new (0, $7c968f807e86b920$export$dc04438abaadc40)();
        if (namespace !== null) {
            if (typeof namespace !== "string") this._namespace = namespace.constructor.name;
            else this._namespace = namespace;
        }
        this._enabled = enabled;
        if (parent === null) this._parent = this;
        else this._parent = parent;
    }
}
class $ec0e259d2aad5b8c$var$GlobalDebugHelper extends $ec0e259d2aad5b8c$var$BasicDebugHelper {
    spawn(namespace = null) {
        return new $ec0e259d2aad5b8c$var$BasicDebugHelper(namespace, this._enabled, this);
    }
    log(...args) {
        if (this._enabled) {
            console.log(...args);
            if (this._visualize) this._visualizer.log(...args);
        }
    }
    warn(...args) {
        if (this._enabled) {
            console.warn(...args);
            if (this._visualize) this._visualizer.warn(...args);
        }
    }
    error(...args) {
        if (this._enabled) {
            console.error(...args);
            if (this._visualize) this._visualizer.error(...args);
        }
    }
}
const $ec0e259d2aad5b8c$export$1c9f709888824e05 = new $ec0e259d2aad5b8c$var$GlobalDebugHelper("Global");


export {$ec0e259d2aad5b8c$export$1c9f709888824e05 as debug};
//# sourceMappingURL=index.mjs.map
